var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Input } from '@angular/core';
import { ConfigureComponentBase } from '../../../../shared/configure-component-base';
import { CreateOrEditConfigureVideoComponent } from './create-or-edit-configure-video.component';
import * as _ from 'lodash';
import { ConfigureVideoDto } from '../../../../shared/service-proxies/service-proxies';
import { VideoTypeHelper } from '../../element-setting/video/video-type-helper';
import { VideoType } from '../../../view-data/components/video/video-type';
var ConfigureVideoComponent = /** @class */ (function (_super) {
    __extends(ConfigureVideoComponent, _super);
    function ConfigureVideoComponent(injector, configVideoService, modalService) {
        var _this = _super.call(this, injector) || this;
        _this.configVideoService = configVideoService;
        _this.modalService = modalService;
        _this.active = false;
        _this.saving = false;
        _this.videoTypeHelper = VideoTypeHelper;
        return _this;
    }
    ConfigureVideoComponent.prototype.loadConfigureVideos = function () {
        var _this = this;
        this.configVideoService.getConfigureVideos(this.configureId).subscribe(function (result) {
            _this.allVideos = result.items || [];
        });
    };
    ConfigureVideoComponent.prototype.addNewVideo = function () {
        var configureVideo = new ConfigureVideoDto();
        configureVideo.configureId = this.configureId;
        configureVideo.videoType = +VideoType.Ezviz;
        this.showConfigureVideoInfo(configureVideo);
    };
    ConfigureVideoComponent.prototype.editVideo = function (configureVideo) {
        this.showConfigureVideoInfo(configureVideo);
    };
    ConfigureVideoComponent.prototype.deleteVideo = function (item) {
        var _this = this;
        this.message.confirm(this.lc('SureToDeleteVideo', item.name), function (isConfirmed) {
            if (isConfirmed) {
                _this.configVideoService.deleteVideo(item.id).subscribe(function () {
                    _this.notify.info(_this.l('SuccessfullyDeleted'));
                    _.remove(_this.allVideos, function (p) {
                        return p.id === item.id;
                    });
                });
            }
        });
    };
    ConfigureVideoComponent.prototype.showConfigureVideoInfo = function (configureVideo) {
        var _this = this;
        var modalRef = this.modalService.show(CreateOrEditConfigureVideoComponent, {
            initialState: {
                configureVideo: _.cloneDeep(configureVideo),
                active: true
            },
            backdrop: 'static', class: 'createOrEditConfigureVideoModal'
        });
        var onClosedSub = modalRef.content.onClosed.subscribe(function (result) {
            if (result) {
                _this.loadConfigureVideos();
            }
            onClosedSub.unsubscribe();
        });
    };
    __decorate([
        Input()
    ], ConfigureVideoComponent.prototype, "configureId", void 0);
    ConfigureVideoComponent = __decorate([
        Component({
            selector: 'configure-video', template: "<div class=\"configure-video\"> <form novalidate> <div class=\"fe-popup-middle\"> <div class=\"add-button\"> <button class=\"fe-btn fe-btn-default fe-btn-save\" (click)=\"addNewVideo()\">{{lc(\"AddVideo\")}}</button> </div> <table class=\"table video-table\"> <thead> <tr> <td>{{lc(\"SerialNumber\")}}</td> <td>{{lc(\"VideoName\")}}</td> <td>{{lc(\"VideoServiceProvider\")}}</td> <td>{{lc(\"VideoUrl\")}}</td> <td>{{l(\"Action\")}}</td> </tr> </thead> <tbody> <tr *ngFor=\"let item of allVideos; let i = index\"> <td> {{i+1}} </td> <td> {{item.name}} </td> <td> {{lc(videoTypeHelper.getVideoTypeName(item.videoType))}} </td> <td> {{item.videoUrl}} </td> <td> <a href=\"javascript:void(0)\" (click)=\"editVideo(item)\">{{l(\"Edit\")}}</a> <a href=\"javascript:void(0)\" (click)=\"deleteVideo(item)\">{{l(\"Delete\")}}</a> </td> </tr> </tbody> </table> </div> </form> </div> ",
            styles: [".configure-video { .video-table { line-height: 29px; margin-bottom: 0; } .video-table th, .video-table td { padding: 0; } .video-table thead tr { background: #f0f1f5; } .video-table { thead tr, tbody tr { display: table; width: 100%; table-layout: fixed; } tbody { display: block; max-height: 304px; overflow: auto; } td:nth-child(1) { width: 10%; } td:nth-child(2) { width: 15%; } td:nth-child(3) { width: 15%; } td:nth-child(4) { width: 45%; word-break: break-all; } td:nth-child(5) { width: 15%; } a { padding-right: 6px; text-decoration: none; color: #3695ff; } } .add-button { margin-bottom: 10px; button { width: 90px; } } } "]
        })
    ], ConfigureVideoComponent);
    return ConfigureVideoComponent;
}(ConfigureComponentBase));
export { ConfigureVideoComponent };
